import axios from 'axios'
import {Message, MessageBox, Notification} from 'element-ui'
import store from '@/store'
import {getToken, removeToken} from '@/utils/auth'
import qs from 'qs'
import i18n from "@/i18n"

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (config.type && config.type == "json") {
      config.headers[config.method]["Content-Type"] = "application/json;charset=UTF-8"
    }
    const contentType = config.headers[config.method]["Content-Type"];
    if (!contentType || contentType.indexOf("application/x-www-form-urlencoded") != -1) {
      config.data = qs.stringify(config.data)
    }
    if (store.getters.token) {
      // let each request carry token
      // ['XD-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['XD-TOKEN'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;

    // if the custom code is not 20000, it is judged as an error.
    if (res.status && res.status !== 'SUCCEED') {
      const msg = i18n.t("message.api." + res.errorCode)
      const code = res.errorCode;
      const codePrefix = res.errorCode.substring(0, 2);
      const type = codePrefix == "01" ? 'error' : 'warning';

      if (code === "0001") {
        MessageBox.alert(i18n.t("message.api.logoutTitle"), i18n.t("message.api.logout"), {
          confirmButtonText: i18n.t("message.api.reLogin"),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          removeToken();
          window.location.reload();
        });
      } else if (type == "error") {
        Message({
          dangerouslyUseHTMLString: true,
          message: msg || 'Error',
          type: type,
          duration: 5 * 1000
        });
      } else if (type == "warning") {
        Notification({
          dangerouslyUseHTMLString: true,
          title: "Message",
          message: msg,
          type: 'warning'
        });
      }
      return Promise.reject(new Error(msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    const {response} = error;
    const url = response.request.responseURL;
    const data = response.data;
    let msg = data.extMessage ? data.extMessage : data.errorMessage;
    msg = !msg ? error.message : msg;
    Message({
      message: url + "<br/>" + msg,
      type: 'error',
      dangerouslyUseHTMLString: true,
      duration: 10 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/admin/utils/request.js